var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-list-group-item',{staticClass:"d-flex justify-content-between align-items-center",on:{"action":_vm.logout}},[_vm._v(" "+_vm._s(_vm.$t('therms.logout'))+" "),_c('b-list-group-item-button',{attrs:{"disable":"","color":"primary"}},[_c('i',{staticClass:"fa-solid fa-right-from-bracket"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }